
import React, { useEffect, useRef, useState } from "react";
import DataTable from "datatables.net-react";
import DT from "datatables.net-dt";
import { Button } from "../StyledElements";

DataTable.use(DT);

const CoursesTable = ({ courses = [], hideTitle = false, onSelect = () => { }, onNewChat = () => { }, onUpdated = () => { }, style = {} }) => {
  const tableRef = useRef(null);
  const [localCourses, setLocalCourses] = useState(courses);
  const [startingChat, setStartingChat] = useState(false);

  useEffect(() => {
    if (courses) {
      setLocalCourses(courses);
    }
  }, [courses]);

  window.view = (public_id) => {
    const chatSession = localCourses.find((cs) => cs.public_id === public_id);
    console.log("!!! VIEW CHAT SESSION: ", public_id, chatSession);
    if (chatSession) {
      onSelect(chatSession);
    }
    //console.log("!!! chatSession VIEW: ", public_id);
    //NiceModal.show("chat-session", { agent: null, chat_session_id: public_id });
  };

  const tableData = localCourses.map((chatSession) => {
    return [
      chatSession.public_id,
      chatSession?.session_type ?? "chat",
      chatSession?.short_summary ?? "Not available",
      chatSession.user,
      chatSession.message_count,
      chatSession.created_at ? new Date(chatSession.created_at) : "",
      chatSession.updated_at ? new Date(chatSession.created_at) : "",
      `<div style="display: flex; flex-direction: row;"><div style="display: flex; flex-direction: row;"><button style="width: 50px; display: flex; flex-direction: column; align-items: center; justify-content: center; font-size: 14px; color: black;" onClick="window.view('${chatSession.public_id}')" class="bg-emerald-400 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button">View</button></div></div>`,
    ];
  });

  return (
    <div style={{ width: "100%", position: "relative", paddingLeft: "20px", paddingRight: "20px", ...style }}>
      <div style={{ fontSize: "32px", fontWeight: "bold" }}>
        {!hideTitle ? (
          <div>Chat Sessions</div>
        ) : null}
        <div style={{ position: "absolute", right: "20px", top: "10px", display: "flex", flexDirection: "row", gap: "10px" }}>
          <Button
            disabled={startingChat}
            onClick={async () => {
              setStartingChat(true);
              await onNewChat();
              setStartingChat(false);
            }}
          >{
              startingChat ? "Starting Chat..." : "+ Start Chat"}</Button>
        </div>
      </div>
      <DataTable
        ref={tableRef}
        data={tableData}
        className="display"
        options={{
          responsive: true,
          select: true,
          pageLength: 25,
          order: [[5, "desc"]],
        }}
      >
        <thead>
          <tr>
            <th>ID</th>
            <th>Type</th>
            <th>Summary</th>
            <th>User</th>
            <th>Message Count</th>
            <th>Created At</th>
            <th>Updated At</th>
            <th>Actions</th>
          </tr>
        </thead>
      </DataTable>
    </div>
  );
};

export default CoursesTable;
